module.exports = __webpack_public_path__ + "static/media/toggle-off.ae769fd9.svg";